import { render, staticRenderFns } from "./UploadImageButton.vue?vue&type=template&id=2e995784&scoped=true"
import script from "./UploadImageButton.vue?vue&type=script&lang=js"
export * from "./UploadImageButton.vue?vue&type=script&lang=js"
import style0 from "./UploadImageButton.vue?vue&type=style&index=0&id=2e995784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e995784",
  null
  
)

export default component.exports